export default "__VITE_ASSET__0LI2iqnI__"